export default function ({ redirect, route }, inject) {
  inject('isInIframe', () => {
    try {
      return window.self !== window.top
    } catch (error) {
      return true
    }
  })
}
